import { FrameApplication } from '@aipb/frame/model';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fr-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule]
})
export class SidebarHeaderComponent {
  // @ts-expect-error foo
  @Input() expanded: boolean;
  // @ts-expect-error foo
  @Input() application: FrameApplication = null;
  // @ts-expect-error foo
  @Input() currentLang: string;
}
